export default __webpack_public_path__ + "static/media/facebook.9cd73363.svg";